import React from 'react'
import { Link } from 'react-router-dom'
import { ShieldCheck } from 'lucide-react'
import MessengerLayout from '../../layout/MessengerLayout'
import './cases.css'

/** The frame.
 *
 *  WHAT CHANGED IN TASK 11B. The standalone app's Shell carried its own
 *  header and its own Sign out, because it was a separate application on
 *  a separate origin with a separate session. Both are gone: the module
 *  is a route inside Kwery now, the session is the Kwery session, and a
 *  second Sign out button would sign the user out of payroll and leave
 *  as well — with no warning that it was about to.
 *
 *  So the chrome is MessengerLayout, the same sidebar every other page
 *  in the application uses. The Cases entry in it is drawn by
 *  CasesNavEntry, which renders nothing for a subject, a reporter, a
 *  witness or a companion; a subject who reached this screen from a link
 *  therefore sees the app they use every day, with no Cases icon in it.
 *
 *  WHAT DID NOT CHANGE, AND MUST NOT. There is still no navigation tree
 *  WITHIN cases, no case search and no sidebar of sections. Every one of
 *  those would be a list of things that exist, and on this surface the
 *  existence of a case is itself the sensitive fact. You reach a case
 *  from your own list or from a link you were sent, and from nowhere
 *  else.
 *
 *  .cases-root is the CSS scope. Everything the ported components draw
 *  lives inside it; see cases.css for why the palette could not simply
 *  be added to tailwind.config.js. */
export default function Shell({ children }) {
  return (
    <MessengerLayout>
      <div className="cases-root min-h-screen">
        <header className="sticky top-0 z-30 border-b border-line bg-black/80 backdrop-blur">
          {/* FULL WIDTH (task 26), so the header's contents line up with
              the page's contents rather than floating in a narrower
              column above them. */}
          <div className="flex w-full items-center gap-2.5 px-5 py-3 sm:px-8">
            <Link to="/cases" className="flex items-center gap-2.5">
              <div className="grid h-8 w-8 place-items-center rounded-[10px] border border-accent-line bg-accent-dim">
                <ShieldCheck size={16} strokeWidth={1.8} className="text-accent" />
              </div>
              <span className="font-head text-[14px] font-bold tracking-tight text-ink">
                Cases
              </span>
            </Link>
          </div>
        </header>

        <main>{children}</main>
      </div>
    </MessengerLayout>
  )
}

/** The same scope with no chrome at all, for the step-up prompt and the
 *  unavailable screen — both of which are shown INSTEAD of a case, not
 *  inside one, and neither of which should sit under a header that
 *  links to a list the user cannot yet reach. */
export function CasesSurface({ children }) {
  return (
    <MessengerLayout>
      <div className="cases-root min-h-screen">{children}</div>
    </MessengerLayout>
  )
}
